import { create } from "zustand";

const STORAGE_KEY = "sidenav_collapsed";

function getInitialCollapsed() {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored !== null) return stored === "true";
  // Default: auto-collapse on narrower viewports
  return typeof window !== "undefined" && window.innerWidth < 1100;
}

export const useSideNavStore = create((set) => ({
  collapsed: getInitialCollapsed(),
  setCollapsed: (value) => {
    sessionStorage.setItem(STORAGE_KEY, String(value));
    set({ collapsed: value });
  },
  toggle: () =>
    set((state) => {
      const next = !state.collapsed;
      sessionStorage.setItem(STORAGE_KEY, String(next));
      return { collapsed: next };
    }),
}));

export const SIDEBAR_WIDE = 240;
export const SIDEBAR_NARROW = 64;
